import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import { ReactNode } from "react-markdown";
import { getContainer } from "../../ioc/IOCSetup";
import { MenuPosition } from "../../http/protocol";
import { useDispatch, useSelector } from "react-redux";
import { setSideMenuPosition, showSideMenu } from "../../navigation/NavigationActions";
import { fetchAndParseContent } from "../../contenful/ContentfulActions";
import { ContentModelName } from "../../contenful/types";
import { AppState } from "../../RootReducer";
import "./styles/MenuLayout.scss";
import "./styles/SideMenu.scss";

import AbsoluteLayout from "./SideMenuAbsolute";
import FixedLayout from "./SideMenuFixed";
interface MenuLayoutProps {
  children: ReactNode[] | ReactNode;
}

export default function MenuLayout(props: MenuLayoutProps) {
  const [position, setposition] = useState<MenuPosition | undefined>(undefined);

  const isExpanded = useSelector((app: AppState) => app.navigation.isSideMenuExpanded);
  const sideMenuContent = useSelector((app: AppState) => app.contentful.sideMenuContent);
  const dispatch = useDispatch();

  const fetchContent = useCallback(() => {
    let locale = getContainer().getSettingsService().getActiveLocale().code;
    return dispatch(fetchAndParseContent(ContentModelName.SIDE_MENU_CONTENT, locale) as any);
  }, []);

  let settings = getContainer().getSettingsService().getMenu().settings;

  useLayoutEffect(() => {
    if (settings && settings.position) {
      if (settings.position == MenuPosition.FIXED && window.innerWidth > 1050) {
        let menuState = localStorage.getItem("menustate");
        if (menuState != null) {
          const menuState = localStorage.getItem("menustate");
          dispatch(showSideMenu(menuState !== "off"));
        } else {
          dispatch(showSideMenu(true));
        }
      }
      if (window.innerWidth < 1050) {
        setposition(MenuPosition.ABSOLUTE);
      } else {
        setposition(settings.position);
      }

      dispatch(setSideMenuPosition(settings.position));
    }
    if (!sideMenuContent) {
      fetchContent();
    }
  }, []);


  const lastDispatchedSideMenuState = useRef<boolean | null>(null); 
  useEffect(() => {
  
    const handleResize = () => {
      if (settings?.position == MenuPosition.FIXED) {
        const isSideMenuHidden = window.innerWidth < 1050;
        if (lastDispatchedSideMenuState.current !== isSideMenuHidden) {
          lastDispatchedSideMenuState.current = isSideMenuHidden;
          if (isSideMenuHidden) {
            setposition(MenuPosition.ABSOLUTE);
            dispatch(showSideMenu(false));
          } else {
            setposition(MenuPosition.FIXED);
          }
        }
      }
    };
  
    window.addEventListener("resize", handleResize);
  
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [settings, dispatch]);

  switch (settings?.position) {
    case MenuPosition.ABSOLUTE:
      return <AbsoluteLayout isExpanded={isExpanded}>{props.children}</AbsoluteLayout>;
    case MenuPosition.FIXED:
      return (
        <FixedLayout position={position} isExpanded={isExpanded}>
          {props.children}
        </FixedLayout>
      );
    default:
      return <></>;
  }
}
